module.exports = __webpack_public_path__ + "img/511-6146b0.png";